var map = {
	"./baby-chart.png": "8f48",
	"./boy-chart.png": "d27f",
	"./girl-chart.png": "84db",
	"./man-chart.png": "512e",
	"./mansenior-chart.png": "502f",
	"./woman-chart.png": "9f5e",
	"./womansenior-chart.png": "b317"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4097";